// Copyright (c) 2016 Deere & Company

import PrimaryProductStatuses, {getDefaultState} from '../state/primary-product-statuses';
import actions from '../../actions-list';

const updatePrimaryProductStatuses = (state, action) =>
     PrimaryProductStatuses.update(state, {
         $set: action.data
     });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.READ_PRIMARY_PRODUCT_STATUSES_SUCCESS]: updatePrimaryProductStatuses
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/status-change-request/reducers/primary-product-statuses.js